module.exports = __webpack_public_path__ + "img/price-table.15341cc2.png";